import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicStorageModule } from '@ionic/storage-angular';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ComponentsModule as OdenComponentsModule } from './components/components.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsModule } from '@ngxs/store';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { VideoSelectPage } from 'src/app/pages/routine/video-select/video-select.page';
import { WodSelectPage } from 'src/app/pages/routine/wod-select/wod-select.page';
import { LanguageService } from './services/language/language.service';
import { RoutineState } from './states/routine/routine.state';
import { ExerciseSelectPage } from 'src/app/pages/routine/exercise-select/exercise-select.page';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastrModule } from 'ngx-toastr';
import { UserGroupSelectPage } from 'src/app/pages/message/user-group-select/user-group-select.page';
import { ModalTagUserComponent } from './components/modal-tag-user/modal-tag-user.component';
import { PopAlertComponent } from './components/pop-alert/pop-alert.component';
import { ModalChangepayComponent } from './components/reports/caja/modal-changepay/modal-changepay.component';
import { DashboardEgressFormPage } from './pages/main-dashboard/dashboard-egress/dashboard-egress-form/dashboard-egress-form.page';
import { MembershipModalComponent } from './pages/shop/membership-modal/membership-modal.component';
import { EditRentComponent } from './pages/shop/purchases/edit-rent/edit-rent.component';
import { TicketPageModule } from './pages/shop/ticket/ticket.module';
import { VentaService } from './services/venta/venta.service';
import { ModalsModule } from './components/modals/modals.module';

export function tokenGetter() {
    const token = localStorage.getItem('token');
    //const s = new Storage();
    //const token = s.get('token');
    return token;
};

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        VideoSelectPage,
        WodSelectPage,
        // PreviewComponent,
        ExerciseSelectPage,
        // ModalGoalsComponent
        ExerciseSelectPage,
        UserGroupSelectPage,
        MembershipModalComponent,
        EditRentComponent,
        DashboardEgressFormPage,
        ModalTagUserComponent,
        ModalChangepayComponent,
    ],
    bootstrap: [AppComponent],
    // exports: [UserGroupSelectPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        BrowserModule,
        NgxSpinnerModule,
        IonicModule.forRoot({
            animated: false,
            innerHTMLTemplatesEnabled: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        IonicStorageModule.forRoot(),
        AppRoutingModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({ toastComponent: PopAlertComponent }),
        NgxChartsModule,
        OdenComponentsModule,
        TicketPageModule,
        FormsModule,
        ReactiveFormsModule,
        // JwtModule.forRoot({
        //   config: {
        //     tokenGetter
        //   }
        // }),
        NgxsModule.forRoot([RoutineState], {
            // developmentMode: !environment.production
        }),
        DragDropModule,
        NgxDaterangepickerMd.forRoot(),
        MatTooltipModule,
        ModalsModule
    ],
    providers: [
        // StatusBar,
        // SplashScreen,
        CurrencyPipe,
        NgxSpinnerService,
        LanguageService,
        VentaService,
        DatePipe,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
